import { render, staticRenderFns } from "./PoinMitraUsaha.vue?vue&type=template&id=60ba4f15&"
import script from "./PoinMitraUsaha.vue?vue&type=script&lang=js&"
export * from "./PoinMitraUsaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports